let Values = {
  _5: '_5',
  _7: '_7',
};

export default Object.seal({
  ...Values,

  /* All values */
  values: Object.keys(Values),

  /* Get name for value. */
  name: (value) => {
    switch (value) {

      case Values._5:
        return '5 capteurs'

      case Values._7:
        return '7 capteurs'

      default:
        console.error("Reached default case")
        break;
    }
  }
});
